import { createStore } from 'stimulus-store';

export const allBundlesStore = createStore({
    name: 'allBundlesStore',
    type: Array,
    initialValue: []
});